import Vue from 'vue'
import VueApollo from 'vue-apollo'
import { ApolloClient } from 'apollo-client'
import { ApolloLink } from 'apollo-link'
import { onError } from "apollo-link-error"
import { HttpLink } from 'apollo-link-http'
import { setContext } from 'apollo-link-context'
import { InMemoryCache } from 'apollo-cache-inmemory'
import { RD_AUTH_TOKEN } from '@/constants/settings'
import router from '@/router/router'

const authLink = setContext((_, { headers }) => {
    // hole Token aus dem sessionstorage
    const token = sessionStorage.getItem(RD_AUTH_TOKEN)

    // set header
    return {
        headers: {
            ...headers,
            authorization: token ? `Bearer ${token}` : null
        }
    }
})

//middleware
const authMiddleware = new ApolloLink((operation, forward) => {
    console.log("wtf");
    const token = sessionStorage.getItem(RD_AUTH_TOKEN)

    if (!token) {
        router.push({ name: 'Login' })
        return false;
    }

    operation.setContext({
        headers: {
            authorization: token ? `Bearer ${token}` : null
        }
    })
    return forward(operation)
})

const httpLinkA = new HttpLink({
    uri: 'https://sedhoapp.dev.sedho.net/ql'
    //uri: 'http://localhost:5000/ql'
})

const httpLinkB = new HttpLink({
    uri: 'https://sedhoapp.dev.sedho.net/xql'
    //uri: 'http://localhost:5000/xql'
})

const errorLink = onError(({ graphQLErrors, networkError }) => {
    if (graphQLErrors)
        graphQLErrors.map(({ message, locations, path }) =>
            console.log(
                `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`
            )
        )
    if (networkError) console.log(`[Network error]: ${networkError}`)
})

export const apolloClientA = new ApolloClient({
    link: ApolloLink.from([
        errorLink,
        authMiddleware,
        httpLinkA
    ]),
    cache: new InMemoryCache(),
    connectToDevTools: true,
})


export const apolloClientB = new ApolloClient({
    link: authLink.concat(httpLinkB),
    cache: new InMemoryCache()
})

// install plugin(s)
Vue.use(VueApollo)

const apolloProvider = new VueApollo({
    clients: {
        apolloClientA,
        apolloClientB
    },
    defaultClient: apolloClientA
})

export default apolloProvider